import React from "react"
import { InnerPageContainer, PageContainer } from "../../Components/pageContainer";
import styled from "styled-components";
import { Marginer } from "../../Components/marginer";
import { TopSection } from "./topSection"
import { InputSection } from "./inputSection"
import { CardSection } from "./cardSection"
import { FooterSection } from "./footer"

const Title = styled.h1`
	font-weight: 900;
	color: #000;
`;
export function HomePage(props) {
	return <PageContainer>
		<TopSection />
		<InnerPageContainer>
		<InputSection />
		<CardSection />
		</InnerPageContainer>
		<FooterSection />

	</PageContainer>
}